import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function useDepartments() {
  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    api.get("/departments").then((r) => setDepartments(r.data)).catch(() => {});
  }, []);
  return departments;
}

export function DeptChips({ ids, departments, testId }) {
  if (!ids?.length) return null;
  const names = ids.map((id) => departments.find((d) => d.id === id)?.name).filter(Boolean);
  return (
    <span data-testid={testId} className="flex items-center gap-1.5 flex-wrap">
      {names.map((n, i) => (
        <span key={`${n}-${i}`} className="text-[10px] font-bold uppercase tracking-wider bg-sky-50 text-sky-700 border border-sky-200 px-2 py-0.5 rounded-full">{n}</span>
      ))}
    </span>
  );
}

export function DepartmentPicker({ value = [], onChange, label = "Target departments", testId = "dept-picker" }) {
  const { user } = useAuth();
  const departments = useDepartments();
  const scoped = user && !["admin", "developer"].includes(user.role) && (user.department_ids || []).length > 0;
  const active = departments.filter((d) => d.active !== false && (!scoped || user.department_ids.includes(d.id)));
  useEffect(() => {
    if (scoped && value.length === 0 && departments.length > 0) onChange(user.department_ids);
  }, [scoped, departments.length]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = (id) => {
    const next = value.includes(id) ? value.filter((v) => v !== id) : [...value, id];
    if (scoped && next.length === 0) return;
    onChange(next);
  };
  if (active.length === 0) return null;
  return (
    <div data-testid={testId}>
      <p className="text-xs uppercase tracking-[0.15em] font-bold text-slate-400 mb-2">
        {scoped ? "Your department scope" : label}
      </p>
      <div className="flex flex-wrap gap-2">
        {!scoped && (
          <button type="button" data-testid={`${testId}-all`} onClick={() => onChange([])}
            className={`h-9 px-4 rounded-full text-xs font-bold tap-press border ${value.length === 0
              ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-500 border-slate-200 hover:border-slate-900"}`}>
            All departments
          </button>
        )}
        {active.map((d) => (
          <button key={d.id} type="button" data-testid={`${testId}-opt-${d.id}`} onClick={() => toggle(d.id)}
            className={`h-9 px-4 rounded-full text-xs font-bold tap-press border ${value.includes(d.id)
              ? "bg-sky-600 text-white border-sky-600" : "bg-white text-slate-500 border-slate-200 hover:border-slate-900"}`}>
            {d.name}
          </button>
        ))}
      </div>
      {scoped && <p className="text-[11px] text-slate-400 mt-2">As a department manager, you can only publish within your assigned department{user.department_ids.length > 1 ? "s" : ""}.</p>}
    </div>
  );
}
